require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("./Box"));

var _Paragraph = _interopRequireDefault(require("./Paragraph"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var BlogPost = function BlogPost(_ref) {
  var _ref$image = _ref.image,
      image = _ref$image === void 0 ? true : _ref$image,
      _ref$imageHeight = _ref.imageHeight,
      imageHeight = _ref$imageHeight === void 0 ? 350 : _ref$imageHeight,
      _ref$paragraphs = _ref.paragraphs,
      paragraphs = _ref$paragraphs === void 0 ? 4 : _ref$paragraphs;
  return _react["default"].createElement("div", null, image ? _react["default"].createElement(_Box["default"], {
    height: imageHeight,
    mb: 60
  }) : null, _react["default"].createElement(_Box["default"], {
    height: image ? 80 : 100,
    width: "78%",
    responsive: true
  }), _react["default"].createElement(_Box["default"], {
    height: image ? 45 : 55,
    width: "40%",
    mb: image ? 50 : 70,
    responsive: true
  }), Array.from(Array(paragraphs), function (e, i) {
    return _react["default"].createElement(_Paragraph["default"], {
      key: i
    });
  }));
};

var _default = BlogPost;
exports["default"] = _default;